// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3HSrK","messages":"Chat_messages__2sWdi","dateDivider":"Chat_dateDivider__3wWOd"};